import React from 'react'
import ReactDOM from 'react-dom/client'
import 'sweetalert2/dist/sweetalert2.min.css'
import { startDeployVersionGuard } from '@huay/shared/deployVersionGuard'
import App from './App'
import './index.css'

startDeployVersionGuard({ appName: 'user-modern' })

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
